<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
			<div class="dp-dept-hint">
				<span class="dp-dept-hint__label">所属机构</span>
				<span class="dp-dept-hint__value">{{ currentDepartmentName || '全部' }}</span>
			</div>
			<div class="all_page_border">
								<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow">
					<el-table-column type="selection" width="50"> </el-table-column>
					<el-table-column prop="DepartmentName" label="班级名称" :formatter="formatDepartmentNameCol"
						min-width="140" show-overflow-tooltip></el-table-column>
					<el-table-column prop="Alias" label="别名" min-width="110" show-overflow-tooltip></el-table-column>
					<el-table-column label="显示别名" width="90" align="center">
						<template slot-scope="scope">
							<el-tag :type="scope.row.ShowAlias ? 'success' : 'info'" size="small">
								{{ scope.row.ShowAlias ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="班级信息摘要" min-width="320">
						<template slot-scope="scope">
							<div class="summary-wrap" @click="openClassDetail(scope.row)">
								<div class="summary-line">
									<span class="summary-label">班级解释：</span>
									<el-tooltip effect="dark" :content="scope.row.ClassNameDesc || '-'" placement="top"
										:open-delay="250">
										<span class="summary-value">{{ shortText(scope.row.ClassNameDesc, 36) }}</span>
									</el-tooltip>
								</div>
								<div class="summary-line">
									<span class="summary-label">班训：</span>
									<el-tooltip effect="dark" :content="scope.row.ClassMotto || '-'" placement="top"
										:open-delay="250">
										<span class="summary-value">{{ shortText(scope.row.ClassMotto, 36) }}</span>
									</el-tooltip>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="详情" width="80" align="center">
						<template slot-scope="scope">
							<el-button type="text" class="detail-btn" @click="openClassDetail(scope.row)">查看</el-button>
						</template>
					</el-table-column>

					<el-table-column prop="ClassLogo" label="班级Logo" align="center" header-align="center" width="95">
						<template slot-scope="scope">
							<div class="thumb-box">
								<oss-media-thumbs v-if="scope.row.ClassLogo" :media="scope.row.ClassLogo" :max="1"
									img-class="thumb-img" />
								<span v-else>-</span>
							</div>
						</template>
					</el-table-column>

					<el-table-column prop="Logo" label="班主任照片" align="center" header-align="center" width="95">
						<template slot-scope="scope">
							<div class="thumb-box">
								<oss-media-thumbs v-if="scope.row.Logo" :media="scope.row.Logo" :max="1"
									img-class="thumb-img" />
								<span v-else>-</span>
							</div>
						</template>
					</el-table-column>

					<el-table-column prop="IsDefault" label="是否默认" width="90" align="center">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsDefault ? 'success' : 'info'">
								{{ scope.row.IsDefault ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>
			<!--编辑界面-->
			<el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible"
				width="760px" custom-class="class-extension-editor-dialog" :close-on-click-modal="false">
				<el-form :model="editForm" label-width="96px" :rules="editFormRules" ref="editForm"
					class="class-extension-editor-form" size="small">
					<el-form-item label="所属机构" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="editForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-row :gutter="16">
						<el-col :xs="24" :sm="12">
							<el-form-item label="别名" prop="Alias">
								<el-input v-model="editForm.Alias" maxlength="50" placeholder="请输入别名"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12">
							<el-form-item label="显示别名" prop="ShowAlias">
								<el-switch v-model="editForm.ShowAlias"></el-switch>
								<span class="form-item-hint-inline">开启后展示为「原名（别名）」</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="16">
						<el-col :xs="24" :sm="12">
							<el-form-item label="班名解释" prop="ClassNameDesc">
								<el-input v-model="editForm.ClassNameDesc" maxlength="500" placeholder="请输入班名解释"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12">
							<el-form-item label="班训" prop="ClassMotto">
								<el-input v-model="editForm.ClassMotto" maxlength="200" placeholder="请输入班训"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="16">
						<el-col :xs="24" :sm="12">
							<el-form-item label="班主任寄语" prop="HeadTeacherMessage">
								<el-input type="textarea" :rows="4" v-model="editForm.HeadTeacherMessage" maxlength="1000"
									placeholder="请输入班主任寄语" resize="vertical"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12">
							<el-form-item label="发展目标" prop="DevelopmentGoal">
								<el-input type="textarea" :rows="4" v-model="editForm.DevelopmentGoal" maxlength="1000"
									placeholder="请输入班级发展目标" resize="vertical"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="16">
						<el-col :xs="24" :sm="12">
							<el-form-item label="Logo">
								<el-upload class="avatar-uploader class-extension-uploader" action="#" :auto-upload="false"
									:show-file-list="false" :on-change="handleClassLogoChange">
									<img v-if="deferredImageDisplay('classLogo', logoImageUrl)"
										v-oss-src="deferredImageDisplay('classLogo', logoImageUrl)" class="avatar" />
									<i v-if="!deferredImageDisplay('classLogo', logoImageUrl)"
										class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12">
							<el-form-item label="班主任照片">
								<el-upload class="avatar-uploader class-extension-uploader" action="#" :auto-upload="false"
									:show-file-list="false" :on-change="handleHeadPicChange">
									<img v-if="deferredImageDisplay('headPic', imageUrl)"
										v-oss-src="deferredImageDisplay('headPic', imageUrl)" class="avatar" />
									<i v-if="!deferredImageDisplay('headPic', imageUrl)"
										class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="是否默认" prop="IsDefault" class="class-extension-default-item">
						<el-switch v-model="editForm.IsDefault"></el-switch>
						<span class="form-item-hint-inline">同一班级仅一条默认；开启后自动取消本班其它默认项</span>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--新增界面-->
			<el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible"
				width="760px" custom-class="class-extension-editor-dialog" :close-on-click-modal="false">
				<el-form :model="addForm" label-width="96px" :rules="addFormRules" ref="addForm"
					class="class-extension-editor-form" size="small">
					<el-form-item label="所属机构" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="addForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-row :gutter="16">
						<el-col :xs="24" :sm="12">
							<el-form-item label="别名" prop="Alias">
								<el-input v-model="addForm.Alias" maxlength="50" placeholder="请输入别名"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12">
							<el-form-item label="显示别名" prop="ShowAlias">
								<el-switch v-model="addForm.ShowAlias"></el-switch>
								<span class="form-item-hint-inline">开启后展示为「原名（别名）」</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="16">
						<el-col :xs="24" :sm="12">
							<el-form-item label="班名解释" prop="ClassNameDesc">
								<el-input v-model="addForm.ClassNameDesc" maxlength="500" placeholder="请输入班名解释"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12">
							<el-form-item label="班训" prop="ClassMotto">
								<el-input v-model="addForm.ClassMotto" maxlength="200" placeholder="请输入班训"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="16">
						<el-col :xs="24" :sm="12">
							<el-form-item label="班主任寄语" prop="HeadTeacherMessage">
								<el-input type="textarea" :rows="4" v-model="addForm.HeadTeacherMessage" maxlength="1000"
									placeholder="请输入班主任寄语" resize="vertical"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12">
							<el-form-item label="发展目标" prop="DevelopmentGoal">
								<el-input type="textarea" :rows="4" v-model="addForm.DevelopmentGoal" maxlength="1000"
									placeholder="请输入班级发展目标" resize="vertical"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="16">
						<el-col :xs="24" :sm="12">
							<el-form-item label="Logo">
								<el-upload class="avatar-uploader class-extension-uploader" action="#" :auto-upload="false"
									:show-file-list="false" :on-change="handleClassLogoChange">
									<img v-if="deferredImageDisplay('classLogo', logoImageUrl)"
										v-oss-src="deferredImageDisplay('classLogo', logoImageUrl)" class="avatar" />
									<i v-if="!deferredImageDisplay('classLogo', logoImageUrl)"
										class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12">
							<el-form-item label="班主任照片">
								<el-upload class="avatar-uploader class-extension-uploader" action="#" :auto-upload="false"
									:show-file-list="false" :on-change="handleHeadPicChange">
									<img v-if="deferredImageDisplay('headPic', imageUrl)"
										v-oss-src="deferredImageDisplay('headPic', imageUrl)" class="avatar" />
									<i v-if="!deferredImageDisplay('headPic', imageUrl)"
										class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="是否默认" prop="IsDefault" class="class-extension-default-item">
						<el-switch v-model="addForm.IsDefault"></el-switch>
						<span class="form-item-hint-inline">同一班级仅一条默认；开启后自动取消本班其它默认项</span>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<el-dialog title="班级扩展详情" :visible.sync="classDetailDialogVisible" width="620px"
				class="class-detail-dialog">
				<div class="detail-inline-row">
					<div class="detail-inline-item">
						<span class="inline-key">班级名称</span>
						<span class="inline-value">{{ classDetailRow.DepartmentName || '-' }}</span>
					</div>
					<div class="detail-inline-item">
						<span class="inline-key">别名</span>
						<span class="inline-value">{{ classDetailRow.Alias || '-' }}</span>
					</div>
					<div class="detail-inline-item">
						<span class="inline-key">显示别名</span>
						<span class="inline-value">{{ classDetailRow.ShowAlias ? '是' : '否' }}</span>
					</div>
				</div>

				<div class="detail-item detail-card">
					<div class="detail-label">班名解释</div>
					<div class="detail-value">{{ classDetailRow.ClassNameDesc || '-' }}</div>
				</div>
				<div class="detail-item detail-card">
					<div class="detail-label">班训</div>
					<div class="detail-value">{{ classDetailRow.ClassMotto || '-' }}</div>
				</div>
				<div class="detail-item detail-card">
					<div class="detail-label">班主任寄语</div>
					<div class="detail-value">{{ classDetailRow.HeadTeacherMessage || '-' }}</div>
				</div>
				<div class="detail-item detail-card">
					<div class="detail-label">发展目标</div>
					<div class="detail-value">{{ classDetailRow.DevelopmentGoal || '-' }}</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="classDetailDialogVisible = false">关闭</el-button>
				</div>
			</el-dialog>

			<el-upload style="display: none;" name="Files" class="quill-upload" :on-success="quillSuccess"
				accept=".png, .jpg, .jpeg" :data="$ossUploadData('DeptExtensionInfo')"
				:action="BaseApiUrl + '/images/Upload/Pic'">
				<i class="el-icon-upload"></i>
			</el-upload>
		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getClassExtensionInfoListPage, editClassExtensionInfo, addClassExtensionInfo, deleteClassExtensionInfo } from '../../api/modules/misc';
import deptCascaderSelectionMixin from '../../mixins/deptCascaderSelectionMixin'
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], // 引用，代码块
	[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], // 列表
	[{ script: 'sub' }, { script: 'super' }], // 上下标
	[{ indent: '-1' }, { indent: '+1' }], // 缩进
	[{ direction: 'rtl' }], // 文本方向
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
	[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
	[{ align: [] }], // 对齐方式
	['clean'], // 清除字体样式
	['image'], // 上传图片
]
export default {
	mixins: [deptCascaderSelectionMixin],
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
			searchList: [
				{
					label: '关键词',
					key: 'name',
				},
			],
			imageUrl: '',
			imageLoadding: false,

			logoImageUrl: '',
			logoImageLoadding: false,

			editorOption: {
				placeholder: '请在这里输入',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							// 重写点击组件上的图片按钮要执行的代码
							image: function (value) {
								if (value) {
									document.querySelector('.quill-upload .el-icon-upload').click()
								} else {
									this.quill.format("image", false);
								}
							}
						}
					}
				},
			},
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],

				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
			},
			//编辑界面数据
			editForm: {
				Id: 0,
				ClassNameDesc: '',
				ClassMotto: '',
				HeadTeacherMessage: '',
				IsDefault: '',
				DevelopmentGoal: '',
				Dids: [],
				DepartmentId: 0,
				Alias: "",
				ShowAlias: false,
				Logo: "",
				ClassLogo: ""
			},

			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
			},
			//新增界面数据
			addForm: {
				ClassNameDesc: '',
				ClassMotto: '',
				HeadTeacherMessage: '',
				IsDefault: '',
				DevelopmentGoal: '',
				Dids: [],
				DepartmentId: 0,
				Alias: "",
				ShowAlias: false,
				Logo: "",
				ClassLogo: ""
			},
			DepartmentId: 0,
			SchoolId: 0,
			multipleSelection: [],
			currentDepartmentName: '',
			classDetailDialogVisible: false,
			classDetailRow: {}
		}
	},
	methods: {
		shortText(text, maxLen = 36) {
			const value = (text || '').trim()
			if (!value) {
				return '-'
			}
			return value.length > maxLen ? `${value.substring(0, maxLen)}...` : value
		},
		openClassDetail(row) {
			this.classDetailRow = Object.assign({}, row || {})
			this.classDetailDialogVisible = true
		},
		getFirstImage(data) {
			const list = this.showImage(data)
			return list.length > 0 ? list[0] : ''
		},

		onEditorBlur() {
			//失去焦点事件
		},
		onEditorFocus() {
			//获得焦点事件
		},
		onEditorChange() {
			//内容改变事件
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.captureDepartmentTreeContext(data, node)
			this.currentDepartmentName = data.label || data.name || ''
			// 向上寻找当前节点所属的学校ID
			let schoolId = 0;
			let tempNode = node;
			while (tempNode) {
				if (tempNode.data && (tempNode.data.DeptOrgType === 'school' || tempNode.data.DeptOrgType === 'affiliateschool')) {
					schoolId = tempNode.data.value;
					break;
				}
				if (tempNode !== node || tempNode.level === 1) {
					if (tempNode.level === 2 || tempNode.level === 1) {
						schoolId = tempNode.data.value;
						break;
					}
				}
				tempNode = tempNode.parent;
			}
			this.SchoolId = schoolId || data.value;
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				departmentId: this.DepartmentId,
			}
			getClassExtensionInfoListPage(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			//NProgress.start();
			getClassExtensionInfoListPage(para).then(async (res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				const rows = res.data.response.data || []
				await this.prefetchListOssMedia(rows, ['ClassLogo', 'Logo'])
				this.users = rows
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		handleRowClick(row) {
			const isSelected = this.multipleSelection.some(item => item.Id === row.Id)
			this.$refs.table.toggleRowSelection(row, !isSelected)
		},
		//显示编辑界面
		handleEdit() {
			var row = this.multipleSelection
			if (row.length == 0 || row.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}
			this.editFormVisible = true
			this.editForm = Object.assign({}, row[0])
			if (this.editForm.Dids) {
				this.$set(this.editForm, 'Dids', this.sanitizeDeptCascaderIds(this.editForm.Dids));
			} else {
				this.$set(this.editForm, 'Dids', []);
			}
			if (typeof this.editForm.ShowAlias !== 'boolean') {
				this.editForm.ShowAlias = !!this.editForm.ShowAlias
			}
			this.imageUrl = this.editForm.Logo
			this.logoImageUrl = this.editForm.ClassLogo;
			this.deferredImageInit('headPic', this.editForm.Logo)
			this.deferredImageInit('classLogo', this.editForm.ClassLogo)

			this.options = []
			this.initDeptFormSelection('edit', row[0].DepartmentId, row[0].Dids).then((path) => {
				this.applyDeptCascaderPath(this.editForm, path)
			}).catch(() => {})
		},
		//显示新增界面
		handleAdd() {
			if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
				this.$message.warning("请先在左侧选择具体的学校机构！");
				return;
			}
			this.addForm = {
				ClassNameDesc: '',
				ClassMotto: '',
				HeadTeacherMessage: '',
				IsDefault: false,
				DevelopmentGoal: '',
				Dids: [],
				DepartmentId: 0,
				Alias: "",
				ShowAlias: false,
				Logo: "",
				ClassLogo: ""
			}
			this.imageUrl = ''
			this.logoImageUrl = ''
			this.deferredImageRevoke('headPic')
			this.deferredImageRevoke('classLogo')
			if (!this.getSchoolIdForDeptCascader()) {
				this.$message.warning("请先在顶部切换学校！");
				return;
			}
			this.options = []
			this.initDeptFormSelection('add', this.DepartmentId).then((path) => {
				this.addFormVisible = true
				this.applyDeptCascaderPath(this.addForm, path)
			}).catch(() => {})
		},
		handleHeadPicChange(file) {
			this.deferredImageChange('headPic', file, { foo: 'DeptExtensionInfo', savedUrl: this.imageUrl })
		},
		handleClassLogoChange(file) {
			this.deferredImageChange('classLogo', file, { foo: 'DeptExtensionInfo', savedUrl: this.logoImageUrl })
		},
		quillSuccess(response) {
			if (response.success) {
				// 获取文本编辑器
				const quill = this.$refs.myQuillEditor.quill
				// 获取光标位置
				const pos = quill.getSelection().index
				// 插入图片到光标位置
				quill.insertEmbed(pos, 'image', this.$resolveImageSrc(response.response))
			} else {
				this.$message({
					message: response.msg,
					type: 'error',
				})
			}
		},
		//编辑
		editSubmit: function () {
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(async () => {
						this.editLoading = true
						try {
							// 班主任照片走 HeadPic（含人脸校验）；上传失败需提示并结束 loading
							this.editForm.Logo = await this.deferredImageEnsure('headPic', {
								endpoint: 'HeadPic',
								foo: 'DeptExtensionInfo',
								currentUrl: this.editForm.Logo
							})
							this.editForm.ClassLogo = await this.deferredImageEnsure('classLogo', {
								foo: 'DeptExtensionInfo',
								currentUrl: this.editForm.ClassLogo
							})
							let para = Object.assign({}, this.editForm)
							para.DepartmentId = para.Dids.pop()
							const res = await editClassExtensionInfo(para)
							if (util.isEmt.format(res)) return
							if (res.data.success) {
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg || '保存失败',
									type: 'error',
								})
							}
						} catch (e) {
							this.$message({
								message: (e && e.message) || '提交失败',
								type: 'error',
							})
						} finally {
							this.editLoading = false
						}
					})
				}
			})
		},
		//新增
		addSubmit: function () {
			let _this = this
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(async () => {
						this.addLoading = true
						try {
							this.addForm.Logo = await this.deferredImageEnsure('headPic', {
								endpoint: 'HeadPic',
								foo: 'DeptExtensionInfo',
								currentUrl: this.addForm.Logo
							})
							this.addForm.ClassLogo = await this.deferredImageEnsure('classLogo', {
								foo: 'DeptExtensionInfo',
								currentUrl: this.addForm.ClassLogo
							})
							let para = Object.assign({}, this.addForm)
							para.DepartmentId = para.Dids.pop()
							var user = JSON.parse(window.localStorage.user)
							if (user && user.uID > 0) {
								para.CreateUser = user.uRealName
							} else {
								this.$message({
									message: '用户信息为空，先登录',
									type: 'error',
								})
								_this.$router.replace(
									_this.$route.query.redirect ? _this.$route.query.redirect : '/'
								)
								return
							}

							const res = await addClassExtensionInfo(para)
							if (util.isEmt.format(res)) return
							if (res.data.success) {
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg || '保存失败',
									type: 'error',
								})
							}
						} catch (e) {
							this.$message({
								message: (e && e.message) || '提交失败',
								type: 'error',
							})
						} finally {
							this.addLoading = false
						}
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})

				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteClassExtensionInfo(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
		// 格式化部门名称：只保留路径的最后两级
		formatDepartmentNameCol(row, column, cellValue) {
			if (!cellValue) return '';
			const parts = cellValue.split('/');
			if (parts.length > 2) {
				return parts.slice(-2).join('/');
			}
			return cellValue;
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}

.form-item-hint {
	margin-top: 6px;
	font-size: 12px;
	color: #909399;
	line-height: 1.5;
}

.form-item-hint-inline {
	margin-left: 10px;
	font-size: 12px;
	color: #909399;
	line-height: 1.4;
	vertical-align: middle;
}

.class-extension-uploader .avatar-uploader-icon,
.class-extension-uploader .avatar {
	width: 148px;
	height: 88px;
	line-height: 88px;
}

.summary-wrap {
	padding: 6px 8px;
	border-radius: 6px;
	transition: background-color .15s ease;
	cursor: pointer;
}

.summary-wrap:hover {
	background: #f7f9fc;
}

.summary-line {
	line-height: 1.8;
	font-size: 12px;
	display: flex;
	align-items: center;
	margin-bottom: 4px;
}

.summary-line:last-child {
	margin-bottom: 0;
}

.summary-label {
	flex: 0 0 auto;
	min-width: 66px;
	color: #909399;
	margin-right: 6px;
}

.summary-value {
	flex: 1;
	color: #303133;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-weight: 500;
	cursor: default;
}

.detail-btn {
	font-weight: 600;
}

.thumb-img {
	width: 42px;
	height: 42px;
	object-fit: cover;
	border-radius: 6px;
	border: 1px solid #ebeef5;
	background: #f5f7fa;
	display: block;
}

.thumb-box {
	width: 42px;
	height: 42px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
}

.detail-item {
	padding: 10px 0;
	border-bottom: 1px solid #ebeef5;
}

.detail-inline-row {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 20px;
	padding: 10px 12px;
	margin-bottom: 12px;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	background: #f8faff;
}

.detail-inline-item {
	display: inline-flex;
	align-items: center;
	font-size: 13px;
}

.inline-key {
	color: #909399;
	margin-right: 6px;
}

.inline-value {
	color: #303133;
	font-weight: 500;
}

.detail-card {
	padding: 10px 12px;
	margin-bottom: 10px;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.detail-card:last-of-type {
	margin-bottom: 0;
}

.detail-label {
	font-size: 12px;
	color: #606266;
	margin-bottom: 8px;
	font-weight: 600;
	letter-spacing: 0.2px;
}

.detail-value {
	max-height: 120px;
	overflow-y: auto;
	white-space: pre-wrap;
	word-break: break-word;
	line-height: 1.8;
	color: #303133;
}

.class-detail-dialog /deep/ .el-dialog__body {
	padding-top: 10px;
	background: #fcfdff;
}

.class-detail-dialog /deep/ .el-dialog__header {
	border-bottom: 1px solid #f0f2f5;
}
</style>

<style>
.class-extension-editor-dialog {
	border-radius: 12px;
	overflow: hidden;
}

.class-extension-editor-dialog .el-dialog__header {
	padding: 16px 20px 12px;
	border-bottom: 1px solid #f1f5f9;
}

.class-extension-editor-dialog .el-dialog__body {
	padding: 18px 20px 8px;
	max-height: min(72vh, 640px);
	overflow-y: auto;
}

.class-extension-editor-dialog .el-dialog__footer {
	padding: 12px 20px 16px;
	border-top: 1px solid #f1f5f9;
}

.class-extension-editor-form .el-form-item {
	margin-bottom: 14px;
}

.class-extension-editor-form .class-extension-default-item {
	margin-bottom: 6px;
}
</style>